export enum MapboxPlaceType {
  Address = 'address',
  Neighborhood = 'neighborhood',
  Locality = 'locality',
  Postcode = 'postcode',
  Place = 'place',
}
